import React from 'react';
import { strategies } from '../data/strategies';
import { StrategyCard } from './StrategyCard';
export function StrategySection() {
  return <section id="strategies" className="py-24 md:py-32 bg-strategies-glow relative" data-id="element-273">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-274">
        <div className="mb-16 max-w-3xl" data-id="element-275">
          <h2 className="text-xs tracking-[0.25em] text-gold-400/70 uppercase mb-4 flex items-center gap-3" data-id="element-276">
            <div className="w-8 h-[1px] bg-gold-400/40" data-id="element-277"></div>
            Strategy Clusters
          </h2>
          <h3 className="text-3xl md:text-5xl text-white leading-tight mb-6" data-id="element-278">
            <span className="font-light" data-id="element-279">Engineered for</span>{' '}
            <span className="font-bold" data-id="element-280">absolute outperformance.</span>
          </h3>
          <p className="text-slate-400 text-lg leading-relaxed" data-id="element-281">
            Explore our 11 core strategy clusters. Each is governed by strict
            mathematical rules, volatility-based weighting, and event-driven
            catalysts to ensure disciplined execution regardless of market
            conditions.
          </p>
        </div>

        {/* Decorative Divider */}
        <div className="flex items-center justify-center mb-16 opacity-50" data-id="element-282">
          <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-slate-800" data-id="element-283"></div>
          <div className="w-3 h-3 border border-gold-400/50 rotate-45 mx-4" data-id="element-284"></div>
          <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-slate-800" data-id="element-285"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8" data-id="element-286">
          {strategies.map((strategy, index) => <StrategyCard key={strategy.id} strategy={strategy} index={index} data-id="element-287" />)}
        </div>
      </div>
    </section>;
}